module.exports = __webpack_public_path__ + "img/slide4.189c788d.jpg";